import React from 'react';

import PropTypes from 'prop-types';

const IconNotes = ({ size, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 13 16">
        <g id="Operations" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
                id="Operations---No-Notifications"
                transform="translate(-1274.000000, -304.000000)"
                fill={fill}
            >
                <g id="Turbine-Filters" transform="translate(10.000000, 265.000000)">
                    <g id="Turbine-Filter---Note" transform="translate(1169.000000, 35.000000)">
                        <g id="Icon-/-Small-/-Note" transform="translate(95.000000, 4.000000)">
                            <g id="Icon---Note">
                                <polygon
                                    id="Fill-1"
                                    points="8.874 4.7923 12.916 4.7923 8.874 0.7513"
                                />
                                <path
                                    d="M0,-0.0002 L0,15.9998 L12.916,15.9998 L12.916,5.8338 L7.749,5.8338 L7.749,-0.0002 L0,-0.0002 Z M2.958,8.2498 L9.874,8.2498 L9.874,6.8748 L2.958,6.8748 L2.958,8.2498 Z M2.958,10.6658 L9.874,10.6658 L9.874,9.2918 L2.958,9.2918 L2.958,10.6658 Z M2.958,13.0828 L9.874,13.0828 L9.874,11.7078 L2.958,11.7078 L2.958,13.0828 Z"
                                    id="Fill-2"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

IconNotes.displayName = 'Notes';

IconNotes.propTypes = {
    size: PropTypes.number.isRequired,
    fill: PropTypes.string.isRequired,
};

IconNotes.defaultProps = {
    size: 12,
    fill: '#FF12C3',
};

export default IconNotes;
